export default "./dist/stdassets/images/icons/out-of-range.png";